import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "reactstrap";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {
  getError,
  IErrorHandler,
  IErrorResponse,
} from "../../helpers/errorHandler";
import { Modal } from "react-bootstrap";

interface IProps {
  errorMessage: any;
}

export const ErrorRequest = (props: IProps) => {
  const { errorMessage } = props;
  const [error, setError] = useState<IErrorResponse>({
    message: "",
    isRecognized: false,
  });

  useEffect(() => {
    if (
      errorMessage?.response?.data?.message &&
      errorMessage.response.data.message.includes("{")
    ) {
      const errorJson = errorMessage.response.data.message.split("{");
      const errorGet: IErrorHandler = JSON.parse(`{${errorJson[1]}`) || "";
      setError(getError(errorGet));
    } else {
      // ERRORES POR DEFAULT
      const errorGet: IErrorHandler = {
        code: "0",
        message: errorMessage?.response?.data?.message || "",
      };
      setError(getError(errorGet));
    }
  }, [props.errorMessage]);

  const getColorIcon = (message: string): string => {
    const messageToShow = message.includes("Error:")
      ? "text-danger"
      : message.includes("Warning:")
      ? "text-warning"
      : "";
    return messageToShow;
  };
  const getMessageToShow = (message: string): string => {
    const messageToShow = message.includes("Error:")
      ? message.replace("Error:", "")
      : message.includes("Warning:")
      ? message.replace("Warning:", "")
      : message;
    return messageToShow;
  };

  return (
    <Modal.Body className="modal-body-generic">
      <Row className="text-center justify-content-center text-danger">
        <FontAwesomeIcon size="3x" icon={faExclamationCircle} />
      </Row>
      <Row className="text-center justify-content-center text-black mt-2 row-response text-modal-title">
        {!error.isRecognized && error.message !== "" && (
          <h5>
            {/* Error */}
            {/* <Translate contentKey="entity.error.undefined">Error</Translate> */}
          </h5>
        )}
        <h4>{getMessageToShow(error.message)}</h4>
      </Row>
    </Modal.Body>
  );
};
